import {
  EChangeTarget,
  EChangeTargetStatus,
} from '../../shared/enums/EChangeTarget';
import {
  IChangeTarget,
  IChangeTargetPagination,
} from '../../shared/interfaces/IChangeTarget';
import { ILogin } from '../../shared/interfaces/ILogin';
import { requests } from '../../utils/api/api.service';
import {
  BASE_URL,
  CHANGE_TARGET_URL,
  LOGIN_URL,
  USER_URL,
} from '../../utils/api/endpoints';

export const AuthService = {
  login: (data: ILogin) => requests.post(LOGIN_URL, data),
  me: (token: string) => requests.get(`${USER_URL}/me`, { token }),
  enums: () => requests.get(`${BASE_URL}/enums`),
  getChangeTarget: <T>(
    data: IChangeTargetPagination,
  ): Promise<IChangeTarget<T>> => requests.get(CHANGE_TARGET_URL, data),
  updateChangeTarget: (data: {
    status: EChangeTargetStatus;
    targetId: string;
    target: EChangeTarget;
  }) => requests.put(`${CHANGE_TARGET_URL}/${data?.targetId}`, data),
};
